import React from 'react';
import './heroOverlay.css';
import overlay from '../assets/images/overlay.jpg';
import { WHATSAPP_URL } from './common/siteLinks';

const HeroOverlay = () => {
  return (
    <div className="hero-overlay">
      <div className="hero-overlay-container">
        
        {/* LEFT TEXT SECTION */}
        <div className="hero-text">
         <h1>
            Your Global Education <br />
            Journey <span>Starts Here!</span>
          </h1>

          <p>
            Take the first step towards your global education dream.
            <br />
            Book a free consultation with our experts.
          </p>

          {/* BUTTONS */}
          <div className="hero-buttons">
            {/* <button className="btn-apply">Apply Now</button> */}
            <a
              className="btn-counseling"
              href={WHATSAPP_URL}
              target="_blank"
              rel="noopener noreferrer"
            >
              Get Free Counseling
            </a>
          </div>
        </div>

        {/* RIGHT IMAGE SECTION */}
        <div className="hero-image">
          <img src={overlay} alt="Student studying" />
        </div>

      </div>
    </div>
  );
};

export default HeroOverlay;
